import { Owner, OwnerOwnerCategoryEnum } from 'api'
import React, { useState } from 'react'
import { ControlPersonDropdown } from './ControlPersonDropdown'
import { Button } from 'reactstrap'
import { OnboardingPageProps } from '../onboardingManager'
import { CreateControlPersonForm } from './uboForms/CreateControlPersonForm'
import { PrimaryOwnerComponent } from '../ownersComponents'
import { EditControlPerson } from './uboForms/EditControlPersonForm'

export function NoControllingShareholders({
  onNext,
  validate,
  handleFieldChange,
  activeClient,
  setCurrentPage,
  formRef,
  setServerErrors,
  setSteps,
  clientOnboarding,
  processingClientOnboarding,
}: OnboardingPageProps): React.ReactElement {
  const [editOwner, setEditOwner] = useState<Owner | null>(null)
  const [createControlPerson, setCreateControlPerson] = useState<boolean>(false)

  function onContinue() {
    onNext({
      processingClientOnboardingValues: {
        ...processingClientOnboarding,
        ownersCompleted: true,
      },
      ownersValues: [...(activeClient.ownersAttributes || [])],
    })

    setCurrentPage(() => ({
      step: 'owners',
      state: 'primary_owner',
      rightPane: (
        <>
          <h3>Why we ask</h3>
          <p>
            We aim to electronically verify all beneficial owners, but we do enhanced verification on the primary
            beneficial owner who has the highest stake in the company.
          </p>
        </>
      ),
      component: PrimaryOwnerComponent,
    }))
  }

  return (
    <div>
      {!createControlPerson && (
        <>
          <h3>{activeClient.operatingAs} - No Controlling Shareholders</h3>
          <div>
            {'No individual owns or controls 25% or more? In that case, we need to collect the information of a '}
            <strong>Control Person</strong>.
          </div>
          <h4>Are any of the following individuals considered a Control Person?</h4>
          <div className="d-flex justify-content-between mb-3 align-items-center">
            <ControlPersonDropdown
              selectedOwner={editOwner}
              setSelectedOwner={(owner) => {
                owner = { ...owner, ownerCategory: OwnerOwnerCategoryEnum.ControlPerson }
                setEditOwner(owner)
              }}
              owners={
                activeClient.ownersAttributes?.filter((o) => o.ownerCategory === OwnerOwnerCategoryEnum.Individual) ||
                []
              }
            />
            <span> or </span>
            <Button
              type="button"
              color="primary"
              className="btn-rotessa-primary"
              onClick={() => {
                setCreateControlPerson(true)
                setEditOwner(null)
                setServerErrors({})
              }}
            >
              Create Control Person
            </Button>
          </div>
        </>
      )}

      {createControlPerson ? (
        <CreateControlPersonForm
          onNext={onNext}
          validate={validate}
          handleFieldChange={handleFieldChange}
          activeClient={activeClient}
          setCurrentPage={setCurrentPage}
          formRef={formRef}
          setServerErrors={setServerErrors}
          setSteps={setSteps}
          clientOnboarding={clientOnboarding}
          processingClientOnboarding={processingClientOnboarding}
          onSuccess={() => {
            setEditOwner(null)
            setCreateControlPerson(false)
            onContinue()
          }}
          onCancel={() => {
            setEditOwner(null)
            setCreateControlPerson(false)
            setServerErrors({})
          }}
        />
      ) : editOwner ? (
        <EditControlPerson
          onNext={onNext}
          editOwner={editOwner}
          validate={validate}
          handleFieldChange={handleFieldChange}
          activeClient={activeClient}
          setCurrentPage={setCurrentPage}
          formRef={formRef}
          setServerErrors={setServerErrors}
          setSteps={setSteps}
          clientOnboarding={clientOnboarding}
          processingClientOnboarding={processingClientOnboarding}
          onSuccess={() => {
            setEditOwner(null)
            setCreateControlPerson(false)
            onContinue()
          }}
          onCancel={() => {
            setEditOwner(null)
            setCreateControlPerson(false)
            setServerErrors({})
          }}
        />
      ) : (
        ''
      )}
    </div>
  )
}
